/* src/app/home-new/tooltip-info-components/tooltip-info-page-size/tooltip-info-page-size.component.scss */
.section_title {
  font-weight: 400 !important;
}
.section_title.primary {
  color: var(--ion-color-primary);
}
.section_title.secondary {
  color: var(--ion-color-secondary);
}
.section_title.tertiary {
  color: var(--ion-color-tertiary);
}
.section_subtitle {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 14px;
  line-height: 14px;
  font-weight: 400;
  color: #949494;
}
/*# sourceMappingURL=tooltip-info-page-size.component-WD7AQFWD.css.map */
